import { SetWallboardType } from "../action-types/wallboard.action.types";
import { Wallboard } from "../actions/wallboard.action";

interface WallboardSockState {
  wallboardMessage: any;
}

const initialState = {
  wallboardMessage: {},
};

const WallboardReducer = (
  state: WallboardSockState = initialState,
  action: Wallboard
): WallboardSockState => {
  switch (action.type) {
    case SetWallboardType.SET_WALLBOARD:
      return {
        ...state,
        wallboardMessage: action.payload,
      };
    default:
      return state;
  }
};

export default WallboardReducer;
